import LoadingIndicator from '../LoadingIndicator/LoadingIndicator'
import './LoadingPage.style.less'

function LoadingPage() {
  return (
    <div className="loading-page-container">
      <LoadingIndicator loading />
    </div>
  )
}

export default LoadingPage
